// extracted by mini-css-extract-plugin
module.exports =  {"logo":"Logo-module_logo_c1b7c","size-S":"Logo-module_size-S_b9b73","size-M":"Logo-module_size-M_dd7f6","size-L":"Logo-module_size-L_a4470","size-XL":"Logo-module_size-XL_bec1d"};